const headers = [
  {
    field: "cli_name",
    headerName: "Cliente",
    width: 180,
    align: "left",
  },
  {
    field: "razon_social",
    headerName: "Razón Social",
    width: 150,
    align: "left",
  },
  {
    field: "distancia_km",
    headerName: "Distancia (km)",
    width: 100,
    align: "center",
  },
  {
    field: "es_principal",
    headerName: "Principal",
    width: 80,
    align: "center",
  },
  {
    field: "asignacion",
    headerName: "Tipo",
    width: 80,
    align: "center",
  }, 
];

export default headers;
